import axios from '../../../../shared/axios/axios';

import * as actionTypes from '../constants/actionTypes';

export const getServiceRequests = (pageRequest) => {
  const url = `/service-requests/get-service-requests-pipelines`;
  return axios
    .post(url, pageRequest)
    .then((response) => (response ? response.data : null))
    .catch((err) => console.log(err));
};

const changeServiceRequestStatusStart = () => {
  return {
    type: actionTypes.CHANGE_SERVICE_REQUEST_STATUS_START,
  };
};

const changeServiceRequestStatusSuccess = () => {
  return {
    type: actionTypes.CHANGE_SERVICE_REQUEST_STATUS_SUCCESS,
  };
};

const changeServiceRequestStatusFail = (error) => {
  return {
    type: actionTypes.CHANGE_SERVICE_REQUEST_STATUS_FAIL,
    error: error,
  };
};

export const changeServiceRequestStatus = (formData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(changeServiceRequestStatusStart());
      const url = `/service-requests/change-status-old`;

      axios
        .post(url, formData)
        .then((response) => {
          dispatch(changeServiceRequestStatusSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(changeServiceRequestStatusFail(err));
          reject(err);
        });
    });
  };
};

const getServiceRequestPipelinesControlConfigStart = () => {
  return {
    type: actionTypes.GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_START,
  };
};

const getServiceRequestPipelinesControlConfigSuccess = (data) => {
  return {
    type: actionTypes.GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_SUCCESS,
    serviceRequestPipelinesControlConfig: data,
  };
};

const getServiceRequestPipelinesControlConfigFail = (error) => {
  return {
    type: actionTypes.GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_FAIL,
    error: error,
  };
};

export const getServiceRequestPipelinesControlConfig = (type) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getServiceRequestPipelinesControlConfigStart());
      const url = `/service-requests/get-sr-pipelines-control-configuration`;

      axios
        .get(url, { params: {pipelineType: type} })
        .then((response) => {
          dispatch(getServiceRequestPipelinesControlConfigSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getServiceRequestPipelinesControlConfigFail(err));
          reject(err);
        });
    });
  };
};

const getServiceRequestPipelinesStagesStart = () => {
  return {
    type: actionTypes.GET_SERVICE_REQUESTS_STAGES_START,
  };
};

const getServiceRequestPipelinesStagesSuccess = (data) => {
  return {
    type: actionTypes.GET_SERVICE_REQUESTS_STAGES_SUCCESS,
    serviceRequestPipelinesStages: data,
  };
};

const getServiceRequestPipelinesStagesFail = (error) => {
  return {
    type: actionTypes.GET_SERVICE_REQUESTS_STAGES_FAIL,
    serviceRequestPipelinesStages: [],
    error: error,
  };
};

export const getServiceRequestPipelinesStages = (request) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getServiceRequestPipelinesStagesStart());
      const url = `/service-requests/get-service-requests-stages`;

      axios
        .get(url, { params: request })
        .then((response) => {
          dispatch(getServiceRequestPipelinesStagesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getServiceRequestPipelinesStagesFail(err));
          reject(err);
        });
    });
  };
};

const changeServiceRequestStageStart = () => {
  return {
    type: actionTypes.CHANGE_SERVICE_REQUEST_STAGE_START,
  };
};

const changeServiceRequestStageSuccess = (data) => {
  return {
    serviceRequestStageChange: data,
    type: actionTypes.CHANGE_SERVICE_REQUEST_STAGE_SUCCESS,
  };
};

const changeServiceRequestStageFail = (error) => {
  return {
    type: actionTypes.CHANGE_SERVICE_REQUEST_STAGE_FAIL,
    error: error,
  };
};

export const changeServiceRequestStage = (request) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(changeServiceRequestStageStart());
      const url = `/service-requests/change-stage`;

      axios
        .post(url, request)
        .then((response) => {
          dispatch(changeServiceRequestStageSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(changeServiceRequestStageFail(err));
          reject(err);
        });
    });
  };
};

const changeServiceRequestCustomTypeStart = () => {
  return {
    type: actionTypes.CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_START,
  };
};

const changeServiceRequestCustomTypeSuccess = (data) => {
  return {
    serviceRequestCustomTypeChange: data,
    type: actionTypes.CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_SUCCESS,
  };
};

const changeServiceRequestCustomTypeFail = (error) => {
  return {
    type: actionTypes.CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_FAIL,
    error: error,
  };
};

export const changeServiceRequestCustomType = (request) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(changeServiceRequestCustomTypeStart());
      const url = `/service-requests/change-custom-type`;

      axios
        .post(url, request)
        .then((response) => {
          dispatch(changeServiceRequestCustomTypeSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(changeServiceRequestCustomTypeFail(err));
          reject(err);
        });
    });
  };
};

const getServiceRequestPipelinesCustomTypesStart = () => {
  return {
    type: actionTypes.GET_SERVICE_REQUESTS_CUSTOM_TYPES_START,
  };
};

const getServiceRequestPipelinesCustomTypesSuccess = (data) => {
  return {
    type: actionTypes.GET_SERVICE_REQUESTS_CUSTOM_TYPES_SUCCESS,
    serviceRequestPipelinesCustomTypes: data,
  };
};

const getServiceRequestPipelinesCustomTypesFail = (error) => {
  return {
    type: actionTypes.GET_SERVICE_REQUESTS_CUSTOM_TYPES_FAIL,
    serviceRequestPipelinesCustomTypes: [],
    error: error,
  };
};

export const getServiceRequestPipelinesCustomTypes = (request) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getServiceRequestPipelinesCustomTypesStart());
      const url = `/service-requests/get-service-requests-custom-types`;

      axios
        .get(url, { params: request })
        .then((response) => {
          dispatch(getServiceRequestPipelinesCustomTypesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getServiceRequestPipelinesCustomTypesFail(err));
          reject(err);
        });
    });
  };
};

const saveServiceRequestPipelinesControlConfigStart = () => {
  return {
    type: actionTypes.SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_START,
  };
};

const saveServiceRequestPipelinesControlConfigSuccess = (data) => {
  return {
    type: actionTypes.SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_SUCCESS,
    saveControlConfigResult: data,
  };
};

const saveServiceRequestPipelinesControlConfigFail = (error) => {
  return {
    type: actionTypes.SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_FAIL,
    error: error,
  };
};

export const saveServiceRequestPipelinesControlConfig = (controlConfig, type) => {
  return (dispatch) => {
    dispatch(saveServiceRequestPipelinesControlConfigStart());
    const url = `/service-requests/save-sr-pipelines-control-configuration`;

    const request = {config: controlConfig, pipelineType: type};

    axios
      .post(url, request)
      .then((response) => {
        dispatch(saveServiceRequestPipelinesControlConfigSuccess(response.data));
        dispatch(getServiceRequestPipelinesControlConfigSuccess(controlConfig));//todo get by type
      })
      .catch((err) => dispatch(saveServiceRequestPipelinesControlConfigFail(err)));
  };
};
